export const copyToClipboard = (text, success, failure) => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();

  const copySuccess = document.execCommand('copy');

  if (copySuccess && success) {
    success();
  } else if (failure) {
    failure();
  }

  document.body.removeChild(el);
}
